// import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

// Constants
import { allergenOptions, cuisineOptions, dietOptions, recipeCategoryOptions } from "@/_constants/recipe";

// Services and interfaces
// import { selectHasTeam } from "@/store/team";

// Components
import { FilterItem } from "@/components/datatable/filter/filter_bar";


const useRecipeFilterItems = (): FilterItem[] => {

    const { t } = useTranslation();
    // const hasTeam = useSelector(selectHasTeam);

    const filters: FilterItem[] = [
        {
            type: 'primary',
            label: t('components.recipeBuilder.category'),
            field: 'categories',
            items: recipeCategoryOptions,
            itemKey: 'value'
        },
        {
            type: 'primary',
            label: t('components.recipeBuilder.diet'),
            field: 'diet',
            items: dietOptions,
            itemKey: 'value'
        },
        {
            type: 'primary',
            label: t('components.recipeBuilder.excludes'),
            field: 'allergens',
            items: allergenOptions,
            itemKey: 'value'
        },
        {
            type: 'primary',
            label: t('components.recipeBuilder.cuisine'),
            field: 'cuisine',
            items: cuisineOptions,
            itemKey: 'value'
        },
        {
            type: 'primary',
            label: t('components.dataTable.headers.status'),
            field: 'published',
            items: [
                { label: t('general.published'), value: true },
                { label: t('general.unpublished'), value: false },
            ],
            itemKey: 'value'
        }
    ];

    return filters;
}

export default useRecipeFilterItems;